import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Footer from "./Footer";
import Seo from "./Seo";
import "./Header.css";

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* HEADER */}
      <header className="site-header">
        {/* BRAND */}
        <Link to="/" aria-label="Go to homepage" className="brand-link">
          <span className="brand-badge">
            <img
              src="/favicon.png"
              alt="BudgetMate logo"
              className="brand-logo"
            />
          </span>
          <div className="brand-text">
            <strong className="brand-title">BudgetMate</strong>
            <small className="brand-sub">Smart Budget App</small>
          </div>
        </Link>

        {/* DESKTOP NAV */}
        <nav className="main-nav">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/privacy" className="nav-link">Privacy Policy</Link>
          <Link to="/terms" className="nav-link">Terms & Conditions</Link>
          <Link to="/about" className="nav-link">About</Link>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </header>

      {/* MOBILE NAV */}
      {menuOpen && (
        <div className="mobile-nav">
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/privacy" onClick={() => setMenuOpen(false)}>Privacy Policy</Link>
          <Link to="/terms" onClick={() => setMenuOpen(false)}>Terms & Conditions</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
        </div>
      )}

      {/* SEO */}
      <Seo />

      {/* PAGE CONTENT */}
      <main>
        <Outlet />
      </main>

      {/* FOOTER */}
      <Footer />
    </>
  );
}

export default Layout;



// import React from "react";
// import { Link, Outlet } from "react-router-dom";
// import { COLORS } from "../constants/colors";
// import Footer from "./Footer";
// import Seo from "./Seo";
// import "./Header.css";

// function Layout() {
//   return (
//     <div style={{ backgroundColor: COLORS.background, minHeight: "100vh" }}>
//       <header className="site-header">
//         <div className="brand">
//           <Link to="/" aria-label="Go to homepage" className="brand-link">
//             <span className="brand-badge" aria-hidden="true">
//               <img src="/favicon.png" alt="BudgetMate logo" className="brand-logo" />
//             </span>
//             <div className="brand-text">
//               <strong className="brand-title">BudgetMate</strong>
//               <small className="brand-sub">Smart Budget App</small>
//             </div>
//           </Link>
//         </div>

//         <nav className="main-nav">
//           <Link to="/" className="nav-link">Home</Link>
//           <Link to="/privacy" className="nav-link">Privacy Policy</Link>
//           <Link to="/terms" className="nav-link">Terms & Conditions</Link>
//           <Link to="/about" className="nav-link">About</Link>
//         </nav>
//       </header>

//       <Seo />

//       <main>
//         <Outlet />
//       </main>

//       {/* Use centralized Footer component so it appears on all pages */}
//       <Footer />
//     </div>
//   );
// }

// export default Layout;
